import {QuizAnswer} from "./QuizAnswer";

export class QuizQuestion {
  id: string;
  text: string;
  imageUrl: string;
  correctAnswerUid: string;
  answers: Array<QuizAnswer>;
  constructor(data: any) {
    this.id = data.questionUid;
    this.text = data.questionText;
    this.imageUrl = data.imageUrl;
    this.correctAnswerUid = data.correctAnswerUid;
    this.answers = data.answers.map((a:any) => new QuizAnswer(a));
  }
}
